import { render, staticRenderFns } from "./QColorPicker.vue?vue&type=template&id=8cd3a5c2&"
import script from "./QColorPicker.vue?vue&type=script&lang=js&"
export * from "./QColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports